/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Storage } from '../storage'
import { Grid } from 'semantic-ui-react'

export class StorageEvolution extends React.Component<Props, State> {
  render() {
    return (
      <div className='storage-evolution'>
        <h3>{this.props.title}</h3>
        <h5>{this.props.subtitle}</h5>
        <Grid stackable doubling columns={3}>
          {/* https://www.mkdiscpress.de/ratgeber/chronik-der-speichermedien/ */}
          <Grid.Column>
            <Storage
              title='Lochkarte'
              year='1890'
              icon={require('../main/img/lochkarte.svg')}
              fontcolor='#2c86b5'
              capacity='~0,08 KB'
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='Magnetband'
              year='1951'
              icon={require('../main/img/magnetband.svg')}
              fontcolor='#00A1CA'
              capacity='~800 KB'
              multiplier1='10&#39;000'
              comparison1={require('../main/img/lochkarte-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='Festplatte'
              year='1956'
              icon={require('../main/img/festplatte.svg')}
              fontcolor='#00A1CA'
              capacity='~5 MB'
              multiplier1='64&#39;000'
              comparison1={require('../main/img/lochkarte-small.svg')}
              multiplier2='201'
              comparison2={require('../main/img/magnetband-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='5,25-Zoll Floppy-Disk'
              year='1976'
              icon={require('../main/img/floppydisk.svg')}
              fontcolor='#00A1CA'
              capacity='110 KB'
              multiplier1='1375'
              comparison1={require('../main/img/lochkarte-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='3,5-Zoll Diskette'
              year='1982'
              icon={require('../main/img/diskette.svg')}
              fontcolor='#00A1CA'
              capacity='1,44 MB'
              multiplier1='18&#39;432'
              comparison1={require('../main/img/lochkarte-small.svg')}
              multiplier2='2'
              comparison2={require('../main/img/magnetband-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='CD-ROM'
              year='1989'
              icon={require('../main/img/cdrom.svg')}
              fontcolor='#E5AC1C'
              capacity='650 MB'
              multiplier1='8,3 Mio.'
              comparison1={require('../main/img/lochkarte-small.svg')}
              multiplier2='832'
              comparison2={require('../main/img/magnetband-small.svg')}
              multiplier3='6051'
              comparison3={require('../main/img/floppydisk-small.svg')}
              multiplier4='451'
              comparison4={require('../main/img/diskette-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='Zip'
              year='1994'
              icon={require('../main/img/zip.svg')}
              fontcolor='#E5AC1C'
              capacity='100 MB'
              multiplier1='1,3 Mio.'
              comparison1={require('../main/img/lochkarte-small.svg')}
              multiplier2='128'
              comparison2={require('../main/img/magnetband-small.svg')}
              multiplier3='931'
              comparison3={require('../main/img/floppydisk-small.svg')}
              multiplier4='69'
              comparison4={require('../main/img/diskette-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='DVD'
              year='1996'
              icon={require('../main/img/dvd.svg')}
              fontcolor='#E5AC1C'
              capacity='4.7 GB'
              multiplier1='44&#39;803'
              comparison1={require('../main/img/floppydisk-small.svg')}
              multiplier2='3342'
              comparison2={require('../main/img/diskette-small.svg')}
              multiplier3='7'
              comparison3={require('../main/img/cdrom-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='USB-Stick'
              year='1999'
              icon={require('../main/img/usbstick.svg')}
              fontcolor='#E5AC1C'
              capacity='~8 MB'
              multiplier1='102&#39;400'
              comparison1={require('../main/img/lochkarte-small.svg')}
              multiplier2='10'
              comparison2={require('../main/img/magnetband-small.svg')}
              multiplier3='64'
              comparison3={require('../main/img/floppydisk-small.svg')}
              multiplier4='6'
              comparison4={require('../main/img/diskette-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='Blu-ray Disc'
              year='2007'
              icon={require('../main/img/bluray.svg')}
              fontcolor='#E03997'
              capacity='25 GB'
              multiplier1='238&#39;313'
              comparison1={require('../main/img/floppydisk-small.svg')}
              multiplier2='17&#39;778'
              comparison2={require('../main/img/diskette-small.svg')}
              multiplier3='39'
              comparison3={require('../main/img/cdrom-small.svg')}
              multiplier4='5'
              comparison4={require('../main/img/dvd-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='SSD'
              year='2009'
              icon={require('../main/img/ssd.svg')}
              fontcolor='#E03997'
              capacity='1 TB'
              multiplier1='9,8 Mio.'
              comparison1={require('../main/img/floppydisk-small.svg')}
              multiplier2='728&#39;178'
              comparison2={require('../main/img/diskette-small.svg')}
              multiplier3='1613'
              comparison3={require('../main/img/cdrom-small.svg')}
              multiplier4='218'
              comparison4={require('../main/img/dvd-small.svg')}
            />
          </Grid.Column>
          <Grid.Column>
            <Storage
              title='Cloud'
              year='2012'
              icon={require('../main/img/cloud.svg')}
              fontcolor='#E03997'
              capacity='~1 Exabyte'
              multiplier1='10,2 Bio.'
              comparison1={require('../main/img/floppydisk-small.svg')}
              multiplier2='763,5 Mrd.'
              comparison2={require('../main/img/diskette-small.svg')}
              multiplier3='1,7 Mrd.'
              comparison3={require('../main/img/cdrom-small.svg')}
              multiplier4='228,5 Mio.'
              comparison4={require('../main/img/dvd-small.svg')}
            />
          </Grid.Column>
        </Grid>
        <div className='source' style={{ marginTop: '1em' }}>
          Quelle: {this.props.source}
        </div>
      </div>
    )
  }
}
